// import { Typography } from '@mui/material';
import Typography from '@/components/shared/typography/typography.component';
// import styled from 'styled-components';
import { ReactNode } from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';
import { IVariant } from '@/components/shared/typography/typography.types';

interface ComponentProps {
    children?: ReactNode;
}

interface CustomTypographyProps extends ComponentProps {
    variant?: IVariant;
}

interface CustomWithStylesProps extends ComponentProps {
    style?: any;
    onClick?: () => void;
}

const ImperfectionContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.ImperfectionContainer}>
            <>{children}</>
        </div>
    );
};
const ImperfectionHeadeContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.ImperfectionHeadeContainer}>
            <>{children}</>
        </div>
    );
};
const ImperfectionHeaderIcon = ({ src, alt }: { src: string; alt: string }) => {
    return (
        <Image
            src={src}
            alt={alt}
            width={102}
            height={62}
            style={{ gap: '8px', width: '102px', height: '62px' }}
        />
    );
};

const ImperfectionHeaderText = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography className={styles.ImperfectionHeaderText} variant={variant}>
            <>{children}</>
        </Typography>
    );
};
const ImperfectionHeaderHighlightedText = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography
            style={{ display: 'inline' }}
            className={styles.ImperfectionHeaderHighlightedText}
            variant={variant}
            component={'span'}
        >
            <>{children}</>
        </Typography>
    );
};

const ImperfectionItemContainer = ({
    children,
    style = {},
    onClick = () => {
        //do nothing
    },
}: CustomWithStylesProps) => {
    return (
        <div
            className={styles.ImperfectionItemContainer}
            style={style}
            onClick={onClick}
        >
            <>{children}</>
        </div>
    );
};

export interface SectionFooterContainerProps {
    isDesktop: boolean;
}

interface SectionFooterContainerPropsWithChildren
    extends SectionFooterContainerProps,
        ComponentProps {}

const SectionFooterContainer = ({
    children,
    isDesktop,
}: SectionFooterContainerPropsWithChildren) => {
    return (
        <div
            className={styles.SectionFooterContainer}
            style={{ justifyContent: isDesktop ? 'space-between' : 'center' }}
        >
            <>{children}</>
        </div>
    );
};
const ImperfectionStatusesContainer = ({ children }: ComponentProps) => {
    return (
        <div className={styles.ImperfectionStatusesContainer}>
            <>{children}</>
        </div>
    );
};
const ImperfectionStatusLegendItem = ({ children }: ComponentProps) => {
    return (
        <div className={styles.ImperfectionStatusLegendItem}>
            <>{children}</>
        </div>
    );
};
export {
    ImperfectionContainer,
    ImperfectionHeadeContainer,
    ImperfectionHeaderIcon,
    ImperfectionHeaderText,
    ImperfectionHeaderHighlightedText,
    ImperfectionItemContainer,
    SectionFooterContainer,
    ImperfectionStatusesContainer,
    ImperfectionStatusLegendItem,
};
